/* eslint-disable indent */
import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import colors, {
  GRAY_SUIT,
  CHATHAMS_BLUE,
  WHITE,
  RADICAL_RED,
  AQUA_HAZE,
} from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ChannelListContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${breakpoints.down('xs')} {
    flex-direction: column-reverse;
  }

  .channel-list {
    &__link {
      ${breakpoints.down('xs')} {
        text-transform: capitalize;
        padding: 5px 5px 20px;
      }
    }
  }
`;

export const Title = styled.span`
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: 600;
  color: ${p =>
    p.type === 'results' || p.type === 'csr-results' || p.type === 'superbundle-results'
      ? colors.text
      : GRAY_SUIT};
  text-transform: uppercase;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-right: ${p =>
    p.type === 'results' || p.type === 'csr-results' || p.type === 'superbundle-results'
      ? '10px'
      : '20px'};
  border-right-width: ${p => (p.type === 'results' ? 0 : '1px')};
  border-right-color: ${GRAY_SUIT};
`;

export const ChannelsContainer = styled.div`
  margin-left: 20px;
  display: flex;
  width: ${p => {
    let width;

    switch (p.type) {
      case 'results':
      case 'csr-results':
        width = 'calc(100% - 240px)';
        break;
      case 'only-channels':
      case 'channels':
      case 'superbundle-results':
        width = 'calc(100% - 278px)';
        break;
      default:
        width = 'calc(100% - 200px)';
        break;
    }
    return width;
  }};

  ${breakpoints.down('sm')} {
    width: ${p => {
      let width;

      switch (p.type) {
        case 'results':
        case 'csr-results':
          width = 'calc(100% - 85px)';
          break;
        case 'channels':
        case 'only-channels':
        case 'superbundle-results':
          width = 'calc(100% - 108px)';
          break;
        default:
          width = 'calc(100% - 200px)';
          break;
      }
      return width;
    }};
  }

  ${breakpoints.down('xs')} {
    margin-left: 0;
    width: 100%;
    box-shadow: 0 1px 0 ${AQUA_HAZE};
  }
`;

export const ChannelsWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Channel = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 50px;
  border-radius: 3px;
  padding: 5px;
  transition: box-shadow 0.4s;
  margin: 7px 8px;

  &:not(.channel--read-only):hover {
    cursor: pointer;
    box-shadow: 0 20px 40px ${rgba(CHATHAMS_BLUE, 0.14)};

    &:before {
      content: '\\e919';
      position: absolute;
      top: -8px;
      right: -8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'icomoon';
      font-size: 10px;
      height: 24px;
      width: 24px;
      border-radius: 50%;
      background-color: ${RADICAL_RED};
      color: ${WHITE};
      z-index: 1;
      transition: 0.5s;
    }
  }

  img {
    display: block;
    max-width: 100%;
    width: 100%;
  }
`;
